import { Component } from "react";
import { withRouter } from "../../../withRouter";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";

import Overview from "./pages/v1/Overview";
import Automations from "./pages/v1/Automations";
import Events from "./pages/v1/Events";
import ManualBlast from "./pages/v1/ManualBlast";
import Analytics from "./pages/v1/Analytics";
import Customers from "./pages/v1/Customers";
import CustomerDetail from "./pages/v1/CustomerDetail";
import Templates from "./pages/v1/Templates";
import TemplateEditor from "./pages/v1/TemplateEditor";
import GrapesJSEditor from "./pages/v1/GrapesJSEditor";
import Settings from "./pages/v1/Settings";


import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import axios from "axios";
import cookie from "react-cookies";
class EngagePlan extends Component {
  constructor(props) {
    super(props);
    const companyID = cookie.load("companyID") || "";
    this.state = {
      companyID: companyID,
      showAddOutlet: true,
    };
  }
  componentDidMount() {
    this.loadOutlet();
  }
  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + this.state.companyID;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
        /*   const result = res.data.result;
         const ids = result
  .filter(item =>
    typeof item?.outletsupabaseReservationOutletID === "string" &&
    item.outletsupabaseReservationOutletID.trim() !== ""
  )
  .map(item => item.outletsupabaseReservationOutletID);
          const emptyOrMissingCount = result.filter((item) => {
            const id = item?.outletsupabaseReservationOutletID;
            return id === null || id === undefined || (typeof id === "string" && id.trim() === "");
          }).length;
          this.setState({ outletList: result, loading: false, supabaseoutletIDs_: ids, showAddOutlet:emptyOrMissingCount>0?true:false }, () => {
            if (this.state.supabaseoutletIDs_.length === 0) {
              this.props.navigate("/clientpanel/reservation/settings");
            }
          }); */
        }
      })
      .catch();
  }
  onRecallOulet(recall) {
    if (recall === true) {
      this.loadOutlet();
    }
  }
  render() {
    const customerID = this.props.params?.id || ''
    const templatid = this.props.params?.templatid || '';
    const gtemplatid = this.props.params?.gtemplatid || '';
    
    let currentPage = "enage-overview";
    if (this.props.location.pathname === "/clientpanel/enage/overview") {
      currentPage = "enage-overview";
    } else if (this.props.location.pathname === "/clientpanel/enage/automations") {
      currentPage = "enage-automations";
    } else if (this.props.location.pathname === "/clientpanel/enage/events") {
      currentPage = "enage-events";
    } else if (this.props.location.pathname === "/clientpanel/enage/blast") {
      currentPage = "enage-blast";
    } else if (this.props.location.pathname === "/clientpanel/enage/analytics") {
      currentPage = "enage-analytics";
    } else if (this.props.location.pathname === "/clientpanel/enage/customers") {
      currentPage = "enage-customers";
    } else if (customerID!=="") {
      currentPage = "enage-view-customers";
    } else if (this.props.location.pathname === "/clientpanel/enage/templates") {
      currentPage = "enage-templates";
    } else if (templatid!=="") {
      currentPage = "enage-edit-templates";
    } else if (gtemplatid!=="") {
      currentPage = "enage-gedit-templates";
    } else if (this.props.location.pathname === "/clientpanel/enage/settings") {
      currentPage = "enage-settings";
    } 
    
    
    
    return (
      <div className="layout-wrapper layout-content-navbar reservation-main ">
        <div className="layout-container engage-main">
          <Header {...this.props} currentPage={currentPage} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                {currentPage==='enage-overview'&& <Overview />}
                {currentPage==='enage-automations'&& <Automations />}
                {currentPage==='enage-events'&& <Events />}
                {currentPage==='enage-blast'&& <ManualBlast />}
                {currentPage==='enage-analytics'&& <Analytics />}
                {currentPage==='enage-customers'&& <Customers />}
                {currentPage==='enage-view-customers'&& <CustomerDetail />}
                {currentPage==='enage-templates'&& <Templates />}
                {currentPage==='enage-edit-templates'&& <TemplateEditor />}
                {currentPage==='enage-gedit-templates'&& <GrapesJSEditor />}
                {currentPage==='enage-settings'&& <Settings />}

              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

export default withRouter(EngagePlan);
